module.exports = __webpack_public_path__ + "media/images/flags/or-db0479c7ec6aaec4add40bd09d505aab.png";